import React, { useEffect, useState } from 'react'

// @componentes
import { ProgramaAcreditacionCalidad } from './ProgramaAcreditacionCalidad'
import { ProgramaEscuela } from './ProgramaEscuela'
import { ProgramaRegistroCalificacion } from './ProgramaRegistroCalificacion'
import { useStep } from 'react-hooks-helper'
import { CAMPOS_PROGRAMA } from './constantes'

const formSteps = [
  { id: 'programa-escuela' },
  { id: 'programa-registro-calificacion' },
]

export const MultiStepForm = ({
  programaAcademico,
  actualizarProgramaAcademico,
  guardarPrograma
}) => {
  /**
   * State
   */
  const [steps, setSteps] = useState(formSteps)

  const { step, navigation } = useStep({
    steps,
    initialStep: 0,
  })

  /**
   * Effects
   */
  useEffect(() => {
    if (!!programaAcademico[CAMPOS_PROGRAMA.PROGRAMA_ACREDITADO]) {
      setSteps(estadoPrevio => ([...estadoPrevio, { id: 'programa-acreditacion-calidad' }]))
    } else {
      setSteps(formSteps)
    }
  }, [programaAcademico])
  

  const props = {
    navigation,
    programaAcademico,
    actualizarProgramaAcademico,
    guardarPrograma
  }

  switch (step.id) {
    case 'programa-escuela':
      return <ProgramaEscuela {...props} />
    case 'programa-registro-calificacion':
      return <ProgramaRegistroCalificacion {...props} />
    case 'programa-acreditacion-calidad':
      return <ProgramaAcreditacionCalidad {...props} />
    default:
      return <></>
  }
}
